import React from 'react';
import { useAppDispatch } from '../../redux';
import ChatBotHeader from './ChatBotHeader';
import { deleteAllMessages } from '../../redux/actions/messages';
const ChatBotHeaderContainer = ({ renderMode, updateBotOpenState }) => {
    const dispatch = useAppDispatch();
    const propsWithRedux = {
        renderMode,
        updateBotOpenState,
        deleteAllMessages: () => dispatch(deleteAllMessages()),
    };
    return React.createElement(ChatBotHeader, Object.assign({}, propsWithRedux));
};
export default ChatBotHeaderContainer;
//# sourceMappingURL=ChatBotHeaderContainer.js.map